export function Logo({ className = "h-12" }: { className?: string }) {
  return (
    <img 
      src="/logo.png" 
      alt="الخدمات الإلكترونية"
      className={className}
    />
  );
}